import { render, staticRenderFns } from "./FixedTerm.vue?vue&type=template&id=b12aea3a"
import script from "./FixedTerm.vue?vue&type=script&lang=js"
export * from "./FixedTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports